interface Props {
    id: string;
    message?: string;
}

export function FieldError({ id, message }: Props) {
    if (!message) return null;

    return (
        <p id={id} role="alert" className="mt-1.5 text-xs text-mp-error">
            {message}
        </p>
    );
}
